import { Utils } from '@microfrontends/react-components'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
    100% {
        transform: translateX(100%);
    }
`

export const CompanyItemWrapper = styled.div<{ isDisplay?: boolean }>`
    width: calc(100% - 16px);
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 6px;
    padding: 8px;
    background-color: #fff;
    border: 1px solid #eee;
    &:nth-child(3n) {
        margin-right: 0;
    }
    @media screen and (max-width: ${Utils.screens.mobile}px) {
        width: calc(100% - 16px);
    }
`

export const FollowCount = styled.div`
    color: #999;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    line-height: 24px;
    width: 100%;
    right: 25px;
    bottom: 15px;

    > svg {
        margin-right: 2px;
        vertical-align: top;
    }
    > button {
        font-size: 12px;
        height: 24px;
        line-height: 24px;
        padding: 2px 2px;
        letter-spacing: -0.2px;
    }
    > span {
        letter-spacing: -0.2px;
    }
`

export const BannerSection = styled.div`
    position: relative;
`

export const CoverWrapper = styled.div`
    width: 100%;
    height: 0;
    padding-top: calc(1 / (64 / 17) * 100%);
    border-radius: 6px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    position: relative;
    overflow: hidden;
    margin-bottom: 8px;
    img {
        object-fit: cover;
    }
`
export const CompanyHeader = styled.div`
    display: flex;
    padding: 0 8px;
`
export const CompanyInfo = styled.div`
    flex-grow: 1;
    padding: 12px 12px 0 12px;
`

export const CompanyLogo = styled.a`
    display: block;
    min-width: 88px;
    max-width: 88px;
    width: 88px;
    height: 88px;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    background-color: #fff;

    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.26);
    img {
        object-fit: contain;
        padding: 8px !important;
    }
`

export const ContentSection = styled.div`
    padding: 16px 8px 8px 8px;
    height: 172px;
`

export const CompanyJob = styled.div`
    display: block;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid #f1f1f1;
    margin-bottom: 8px;
    p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 0px;
        line-height: 18px;
    }
    .job-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: left;
        margin-bottom: 4px;
    }
    .job-salary {
        color: #ff7d55;
        font-size: 14px;
    }
    .job-location {
        color: #797979;
        font-size: 14px;
    }
`

export const CompanyName = styled.a`
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #333;
    margin-bottom: 6px;
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
`

export const CompanyCategories = styled.div<{ color: string }>`
    font-size: 14px;
    line-height: 17px;
    height: 17px;
    color: ${({ color }) => color};
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    margin-bottom: 6px;
    word-break: break-all;
    svg {
        vertical-align: top;
        margin-right: 3px;
        margin-top: 2px;
    }
`

export const FollowSection = styled.div`
    padding: 0 8px 16px 8px;
    button {
        width: 100%;
    }
`
